import { createContext } from 'react';
import { useNavApi } from './useNavApi';

export const NavContext = createContext<ReturnType<typeof useNavApi>>(null);
NavContext.displayName = 'Fusion Nav Items';
